import { openSuccessToaster } from 'helpers/toaster.helpers'
import { getTranslation } from 'helpers/translations.helpers'
import store from 'index'
import { stopLoader } from 'redux-thunk/redux/slices/loader.slice'

export const responseSuccessHandler = (response) => {
  const { responseType = 'json', successMessage, loader, showApiSuccessMessage } = response.config || {}
  if (responseType === 'blob') {
    return { file: response.data, headers: response.headers }
  }
  // Loader logic to remove loader
  if (loader) {
    store.dispatch(stopLoader(loader))
  }

  const apiMessage = response.data?.data?.message
  if (showApiSuccessMessage && apiMessage) {
    openSuccessToaster({ message: apiMessage })
  }

  // Open Success Toaster
  successMessage && openSuccessToaster({ message: getTranslation(successMessage) })
  return response.data.data
}
